module.exports = __webpack_public_path__ + "bf78b05af1f7c4ac8d8567a016ee1cf1.png";